import React from 'react';
import { type QueryComponentOptions, Query } from '@apollo/react-components';
import gqlTagSwag from 'graphql-tag';

export const PROJECT_CONFIG_QUERY = gqlTagSwag`
    query ProjectConfigQuery($boardId: ID!) {
        boardScope(boardId: $boardId) {
            features {
                key
                status
            }
        }
    }
`;

export type Variables = {
	boardId: number;
};

type Response = {
	boardScope: {
		features: [
			{
				key: string;
				status: string;
			},
		];
	};
};

export type Props = Omit<QueryComponentOptions<Response, Variables>, 'query'>;

const ProjectConfigQuery = (props: Props) => (
	<Query<Response, Variables> query={PROJECT_CONFIG_QUERY} fetchPolicy="no-cache" {...props} />
);

export default ProjectConfigQuery;
